import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const StyledBreadcrumbsNav = styled.nav``

export const StyledMobileBreadcrumbs = styled.div`
  display: flex;
  margin-right: 8px;

  @media ${theme.devices.desktop} {
    display: none;
  }
`

export const StyledDesktopBreadcrumbs = styled.div`
  display: none;

  @media ${theme.devices.desktop} {
    display: flex;
    align-items: center;
    margin-right: ${theme.spacing.base};
  }
`

export const StyledBreadcrumbsPath = styled.button`
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 7px 7px 7px 16px;
  ${Font14};
  border: 1px solid ${theme.colors.lightGrey};
  border-radius: 8px;
  background-color: ${theme.colors.white};
  animation: ${theme.animations.fadeIn} 0.3s ease-out;
  cursor: pointer;
  overflow: hidden;
`

export const StyledBreadcrumbsPathTitle = styled.span`
  direction: rtl;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StyledBreadcrumbsPathIcon = styled(Icon)`
  color: ${theme.colors.duneWarmGrey};
  margin-left: 5px;
`

export const StyledBreadcrumbsMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  padding-top: 75px;
  /* mobile viewport bug fix */
  height: -webkit-fill-available;
  background: ${theme.colors.grey};
  backdrop-filter: ${theme.overlay.SBlur};
  overflow: auto;
  z-index: ${theme.zIndex.loaderOverlay};
`

export const StyledBreadcrumbsMenuHeader = styled.header`
  margin: 12px;
`

export const StyledBreadcrumbsMenuBody = styled.main`
  padding: 0 12px;
`

export const StyledBreadcrumbsMenuFooter = styled.footer`
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  width: 100%;
  padding: 12px 24px;
  gap: ${theme.spacing.sm};
`
